import React from 'react';
import { CustomModal } from '../../../../../common/CustomModal';
import '../../../../../../styles/components/auction-client-pay.scss';
import { TableSkeleton } from '../../../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../../i18n';
import NoData from '../../../../../common/NoData';
import StatusBadge from '../../../../../common/StatusBadge';
import { CLIENT_APPROVAL } from '../../../../../../constants/status';
import ProjectCardSkeleton from '../../../../../common/skelton/ProjectCardSkelton';
import ProjectCard from '../../../../../common/ProjectCard';
import {
  Banknote,
  BanknoteArrowDown,
  BanknoteArrowUp,
  CircleArrowDown,
  Landmark,
  Wallet,
} from 'lucide-react';

export class PaymentTransaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      isloading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.fetchPayments();
    }
  }

  fetchPayments = async () => {
    const { title } = this.props;

    this.setState({ isloading: true });

    let transactions = [];
    let meta = {};

    /* =========================================
     AUCTION PAYMENT PAID
  ========================================= */
    if (title?.toLowerCase().includes('completed')) {
      transactions = [
        {
          id: 1,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-1001',
          auction_name: 'Luxury Villa Auction',
          group_name: 'Premium Group',
          client_name: 'Ahmed Al Balushi',
          paid_amount: 4850,
          payment_method: 'online',
          invoice: 'INV-2026-001',
          attachment_url: 'https://example.com/uploads/invoices/invoice-001.pdf',
          status: 2,
        },
        {
          id: 2,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-1002',
          auction_name: 'Car Number Plate Auction',
          group_name: 'VIP Bidders',
          client_name: 'Mohammed Al Hinai',
          paid_amount: 3250,
          payment_method: 'wallet',
          invoice: 'INV-2026-002',
          attachment_url: 'https://example.com/uploads/invoices/invoice-002.pdf',
          status: 2,
        },
        {
          id: 3,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-1003',
          auction_name: 'Heavy Equipment Auction',
          group_name: 'Industrial Group',
          client_name: 'Salim Al Riyami',
          paid_amount: 9200,
          payment_method: 'offline',
          invoice: 'INV-2026-003',
          attachment_url: 'https://example.com/uploads/invoices/invoice-003.pdf',
          status: 2,
        },
        {
          id: 4,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-1004',
          auction_name: 'Electronics Auction',
          group_name: 'Retail Buyers',
          client_name: 'Khalid Al Lawati',
          paid_amount: 1780,
          payment_method: 'online',
          invoice: 'INV-2026-004',
          attachment_url: 'https://example.com/uploads/invoices/invoice-004.pdf',
          status: 2,
        },
      ];
      meta = {
        total_count: transactions.length,
        online: transactions
          .filter((t) => t.payment_method === 'online')
          .reduce((sum, t) => sum + t.paid_amount, 0),
        offline: transactions
          .filter((t) => t.payment_method === 'offline')
          .reduce((sum, t) => sum + t.paid_amount, 0),
        wallet: transactions
          .filter((t) => t.payment_method === 'wallet')
          .reduce((sum, t) => sum + t.paid_amount, 0),
      };
    } else {
      /* =========================================
     AUCTION PAYMENT PENDING
  ========================================= */
      transactions = [
        {
          id: 1,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2001',
          auction_name: 'Luxury Watch Auction',
          group_name: 'Gold Members',
          client_name: 'Faisal Al Farsi',
          total_amount: 5500,
          paid_amount: 2500,
          payable_balance: 3000,
          due_date: '25 May 2026',
          invoice: 'INV-2026-101',
          status: 1,
        },
        {
          id: 2,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2002',
          auction_name: 'Property Land Auction',
          group_name: 'Real Estate Group',
          client_name: 'Hassan Al Kindi',
          total_amount: 12000,
          paid_amount: 5000,
          payable_balance: 7000,
          due_date: '28 May 2026',
          invoice: 'INV-2026-102',
          status: 1,
        },
        {
          id: 3,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2003',
          auction_name: 'Classic Car Auction',
          group_name: 'Auto Enthusiasts',
          client_name: 'Majid Al Shukaili',
          total_amount: 8900,
          paid_amount: 3900,
          payable_balance: 5000,
          due_date: '30 May 2026',
          invoice: 'INV-2026-103',
          status: 1,
        },
        {
          id: 4,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2004',
          auction_name: 'Jewellery Auction',
          group_name: 'Diamond Club',
          client_name: 'Saeed Al Habsi',
          total_amount: 7600,
          paid_amount: 2600,
          payable_balance: 5000,
          due_date: '02 Jun 2026',
          invoice: 'INV-2026-104',
          status: 1,
        },
        {
          id: 5,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2001',
          auction_name: 'Luxury Watch Auction',
          group_name: 'Gold Members',
          client_name: 'Faisal Al Farsi',
          total_amount: 5500,
          paid_amount: 2500,
          payable_balance: 3000,
          due_date: '25 May 2026',
          invoice: 'INV-2026-101',
          status: 1,
        },
        {
          id: 6,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2002',
          auction_name: 'Property Land Auction',
          group_name: 'Real Estate Group',
          client_name: 'Hassan Al Kindi',
          total_amount: 12000,
          paid_amount: 5000,
          payable_balance: 7000,
          due_date: '28 May 2026',
          invoice: 'INV-2026-102',
          status: 1,
        },
        {
          id: 7,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2003',
          auction_name: 'Classic Car Auction',
          group_name: 'Auto Enthusiasts',
          client_name: 'Majid Al Shukaili',
          total_amount: 8900,
          paid_amount: 3900,
          payable_balance: 5000,
          due_date: '30 May 2026',
          invoice: 'INV-2026-103',
          status: 1,
        },
        {
          id: 8,
          bidder_name: 'Ali Al Harthy',
          auction_id: 'MZAD-2004',
          auction_name: 'Jewellery Auction',
          group_name: 'Diamond Club',
          client_name: 'Saeed Al Habsi',
          total_amount: 7600,
          paid_amount: 2600,
          payable_balance: 5000,
          due_date: '02 Jun 2026',
          invoice: 'INV-2026-104',
          status: 1,
        },
      ];
      meta = {
        total_count: transactions.length,
        total_amount: transactions.reduce((sum, t) => sum + t.total_amount, 0),
        paid_amount: transactions.reduce((sum, t) => sum + t.paid_amount, 0),
        payable_balance: transactions.reduce((sum, t) => sum + t.payable_balance, 0),
      };
    }

    setTimeout(() => {
      this.setState({
        transactions,
        meta,
        isloading: false,
      });
    }, 500);
  };

  getColumns = () => {
    const { title } = this.props;
    const isPending = title?.toLowerCase().includes('pending');

    return [
      {
        name: i18n.t('sl_no'),
        width: '90px',
        sortable: true,
        cell: (row, i) => i + 1,
      },
      {
        name: 'Bidder Name',
        minWidth: '120px',
        cell: (row) => row.bidder_name,
      },
      {
        name: 'Auction ID',
        minWidth: '120px',
        cell: (row) => <span className="highlight-table-value">{row.auction_id}</span>,
      },

      {
        name: 'Auction Name',
        minWidth: '140px',
        cell: (row) => row.auction_name,
      },

      {
        name: 'Group Name',
        minWidth: '140px',
        cell: (row) => row.group_name,
      },

      {
        name: 'Client Name',
        minWidth: '140px',
        cell: (row) => row.client_name,
      },

      ...(isPending
        ? [
            {
              name: 'Total Amount',
              width: '120px',
              right: true,
              cell: (row) => row.total_amount,
            },
            {
              name: 'Paid Amount',
              width: '120px',
              right: true,
              cell: (row) => row.paid_amount,
            },
            {
              name: 'Payable Balance',
              width: '140px',
              right: true,
              cell: (row) => row.payable_balance,
            },
            {
              name: 'Due Date',
              width: '120px',
              cell: (row) => row.due_date || '-',
            },

            {
              name: i18n.t('due_days'),
              width: '120px',
              cell: (row) => {
                if (!row.due_date) return '-';

                const dueDate = new Date(row.due_date);
                const today = new Date();

                const diffTime = dueDate.getTime() - today.getTime();

                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                const isOverdue = diffDays < 0;

                const displayText = isOverdue
                  ? `${Math.abs(diffDays)} days overdue`
                  : `${diffDays} days left`;

                return (
                  <span className={`highlight-table-value ${isOverdue ? 'overdue' : 'upcoming'}`}>
                    {displayText}
                  </span>
                );
              },
            },
          ]
        : [
            {
              name: 'Paid Amount',
              width: '120px',
              right: true,
              cell: (row) => row.paid_amount,
            },
            {
              name: 'Pay Method',
              width: '120px',
              cell: (row) => {
                const method = row.payment_method;

                const label =
                  method === 'online' ? 'Online' : method === 'offline' ? 'Offline' : 'Wallet';

                return <span className={`payment-method ${method}`}>{label}</span>;
              },
            },
            {
              name: 'Attachment',
              width: '120px',
              center: true,
              cell: (row) => (
                <a
                  href={row.attachment_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="button-table"
                >
                  View File
                </a>
              ),
            },
          ]),

      {
        name: 'Invoice',
        minWidth: '120px',
        cell: (row) => row.invoice,
      },

      {
        name: i18n.t('status'),
        width: '120px',
        cell: (row) => <StatusBadge status={CLIENT_APPROVAL[row.status]} />,
        center: true,
      },
    ];
  };

  handleCancel = () => {
    this.setState({
      transactions: [],
    });
    this.props.onClose();
  };

  render() {
    const { show, title } = this.props;
    const { transactions } = this.state;
    const { meta } = this.state;
    const isCompleted = title?.toLowerCase().includes('completed');
    const summaryCards = isCompleted
      ? [
          {
            title: 'Online',
            amount: meta?.online || 0,
            icon: BanknoteArrowUp,
            className: 'Approved',
          },
          {
            title: 'Offline',
            amount: meta?.offline || 0,
            icon: BanknoteArrowDown,
            className: 'Rejected',
          },
          {
            title: 'Wallet',
            amount: meta?.wallet || 0,
            icon: Wallet,
            className: 'FundAdded',
          },
        ]
      : [
          {
            title: 'Total Amount',
            amount: meta?.total_amount || 0,
            icon: Landmark,
            className: 'FundAdded',
          },
          {
            title: 'Paid Amount',
            amount: meta?.paid_amount || 0,
            icon: Banknote,
            className: 'Approved',
          },
          {
            title: 'Balance',
            amount: meta?.payable_balance || 0,
            icon: CircleArrowDown,
            className: 'Rejected',
          },
        ];

    return (
      <CustomModal
        isOpen={show}
        header={title}
        onClose={this.handleCancel}
        modalClassName="modal-l2-xl"
      >
        <div className="summary-report">
          <div className="summary-report__content">
            {this.state.isSummaryLoading
              ? [...Array(3)].map((_, idx) => <ProjectCardSkeleton key={idx} />)
              : summaryCards.map((item, idx) => {
                  const Icon = item.icon;

                  return (
                    <ProjectCard
                      key={idx}
                      className={item.className}
                      icon={Icon}
                      title={item.title}
                      amount={item.amount}
                    />
                  );
                })}
          </div>
        </div>
        <div className="Data-Listing">
          {this.state.isloading ? (
            <TableSkeleton columns={5} rows={2} />
          ) : transactions.length ? (
            <DataTable
              keyField={(row) => `${row.id}`}
              responsive={true}
              columns={this.getColumns()}
              data={transactions}
              customStyles={tableStyles}
              highlightOnHover
            />
          ) : (
            <NoData message={i18n.t('no_transaction_available')} />
          )}
        </div>
      </CustomModal>
    );
  }
}
